<template>
	<div class="intro_page">
		<div class="position ">
			<div class="w1">当前位置：
				<router-link :to="'home'">首页</router-link>>
				<a style="text-decoration: none;">{{nodeName}}</a>
				<!-- <router-link :to="'intro?id='+nodeId">{{nodeName}}</router-link> -->
			</div>
		</div>

		<div class="w1"><!--w1 -->

			<div class="wrap_group1  mb_1"><!--wrap_group1 -->
				<div class="wrap_group1_L "><!--wrap_group1_L -->

					<div class="leftmenu"><!--leftmenu -->
						<div class="Nav  current">
							<l>{{nodeName}}</l>
						</div>
						<ul class="subContent" v-if="arrNodeTree.length>0">
							<li v-for="(item,index) in arrNodeTree" @click="changecol(item.fdnodeid,item.fdname)"
								:class="selId==item.fdnodeid?'on':''">
								<a>{{item.fdname}}</a>
							</li>
						</ul>
					
					</div><!--/leftmenu -->


				</div><!--/wrap_group1_L -->
				<div class="wrap_group1_R" v-loading="loadingMask"><!--wrap_group1_R -->


					<div class="main_title">{{articleTitle}}</div>

					<div class="main_title_info">发布日期：{{articleDate}}</div>

					<div class="main_text" v-html="articleHtml"><!--main_text -->
					</div><!--/main_text -->


				</div><!--/index_group1_R -->
			</div><!--/wrap_group1 -->



		</div><!--/w1 -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: true,
				nodeId: '',
				nodeName: '',
				arrNodeTree: [],
				selId: '',
				selName: '',
				articleId: '',
				articleTitle: '',
				articleDate: '',
				articleHtml: '',
			}
		},
		components: {
	
		},
		watch: {
			$route(to, from) {
				if (to.query.id != from.query.id) {
					this.getNodeTree();
				}
			}
		},
		created: function() {
			this.getNodeTree();
		},
		mounted: function() {
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		methods: {
			getNodeTree: function() {
				var _this = this;
				this.nodeId = this.$route.query.id;
				if (this.nodeId) {
					this.$http({
							method: 'get',
							url: 'chinaculturalindustrypromotion/tbappchanneltree/list',
							responseType: 'json',
							params: {
	
							},
						})
						.then(function(response) {
							if (response.data.code == 0) {
								_this.arrNodeTree = [];
								let temptree = response.data.page.list;
								for (var i = 0; i < temptree.length; i++) {
									if (temptree[i].fdnodeid == _this.nodeId) {
										_this.nodeName = temptree[i].fdname;
									}
									if (temptree[i].fdparentid == _this.nodeId) {
										_this.arrNodeTree.push(temptree[i]);
									}
								}
								if (_this.arrNodeTree.length > 0) {
									_this.changecol(_this.arrNodeTree[0].fdnodeid, _this.arrNodeTree[0].fdname);
								} else {
									_this.changecol(_this.nodeId, _this.nodeName);
								}
							} else {
								_this.arrNodeTree = [];
							}
						})
						.catch(function(error) {
							alert('数据获取出错！');
						});
				}
			},
			changecol: function(colid, colname) {
				this.selId = colid;
				this.selName = colname;
				this.pageNum = 1;
				this.pageSize = 1;
				this.getArticleList();
			},
			getArticleList: function() {
				this.loadingMask = true;
				var _this = this;
				this.$http({
						method: 'get',
						url: 'chinaculturalindustrypromotion/tbapparticleinfo/list',
						responseType: 'json',
						params: {
							nodeId: this.selId,
							pageIndex: this.pageNum,
							pageSize: this.pageSize,
						},
					})
					.then(function(response) {
						if (response.data.code == 0&&response.data.list.data.length>0) {
							_this.articleId = response.data.list.data[0].id;
							_this.getArticle();
						}
						// _this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log('数据获取出错！');
					});
			},
			getArticle: function() {
				this.loadingMask = true;
				var _this = this;
				this.$http({
						method: 'get',
						url: '/chinaculturalindustrypromotion/tbapparticleinfo/info/' + _this.articleId,
						responseType: 'json',
						params: {
			
						},
					})
					.then(function(response) {
						if (response.data.code == 0) {
							//console.log(response.data);
							_this.articleTitle = response.data.tbapparticleinfo.fdarticletitle;
							_this.articleDate = response.data.tbapparticleinfo.fdpublishtime.substring(0, 10);
							//处理视频和pdf
							var temphtml = response.data.tbapparticleinfo.fdhtmlcontent;
							if (process.env.NODE_ENV === 'development') {
								temphtml = temphtml.replace(/\/web\/tbappattachments/g, '/proxyapi/web/tbappattachments');
							}
							if (temphtml.indexOf("/web/tbappattachments/getFile?filetype=") > -1) {
								// debugger
								var regtaga = RegExp(/<a.*?a>/g);
								var temphtmlarr = temphtml.match(regtaga);
								if (temphtmlarr) {
									for (var i = 0; i < temphtmlarr.length; i++) {
										if (temphtmlarr[i].indexOf("filetype=video") > -1) {
											var regsrc = RegExp(/href="(.*?)"/);
											var tempsrc = regsrc.exec(temphtmlarr[i])[1];
											tempsrc = tempsrc.replace("getFile", "getVideo");
											temphtml = temphtml.replace(temphtmlarr[i], "<video controls='controls' width='100%' src='" +
												tempsrc + "'></video>");
										} else if (temphtmlarr[i].indexOf("filetype=pdf") > -1) {
											var regsrc = RegExp(/href="(.*?)"/);
											var tempsrc = regsrc.exec(temphtmlarr[i])[1];
											temphtml = temphtml.replace(temphtmlarr[i],
												"<iframe id='documentViewer' src='/pdfjs/web/viewer.html?file=" + encodeURIComponent(
													tempsrc) + "' style='width:100%;height:8rem;'></iframe>");
										}
									}
								}
							}
							_this.articleHtml = temphtml;
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						alert('数据获取出错！');
					});
			},
	
		}
	}
</script>

<style>
</style>